<template>
  <v-card>
    <v-container fluid grid-list-sm>
      <v-toolbar :dense="true" >
        <v-toolbar-title><v-icon>mdi-chart-areaspline</v-icon> Statistics</v-toolbar-title>
        <v-spacer></v-spacer>
        <span class="body-2">Claim No: {{ this.commonInfo.clmNo }}</span>
      </v-toolbar>
      <template v-if="isMatchRouteExact('claimHeader') || isMatchRouteExact('qClaimHeader')">
        <v-card-text>
          <template v-if="statisticses.length > 0">
            <v-layout row wrap v-for="(statistics, index) in statisticses" :key="statistics.statType" align-center>
              <v-flex xs6>
                <v-subheader class="queryLabel">
                  <span>{{ statistics.statsTypeDesc }}</span>
                </v-subheader>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  v-validate="{ required: true }"
                  v-model="statistics.selectedVal"
                  :items="statistics.statValList"
                  label="Statistics"
                  item-text="label"
                  item-value="value"
                  :data-vv-name="'Statistics' + (index + 1)"
                  :data-vv-as="'Statistics' + (index + 1)"
                  :error-messages="errors.collect('Statistics' + (index + 1))"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </template>
          <template v-else>
            <v-layout justify-center>
              <div>No Statistic Found</div>
            </v-layout>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="doCancel">Cancel</v-btn>
          <v-btn color="primary" text @click="doValidate">Save</v-btn>
        </v-card-actions>
      </template>
      <template v-else-if="isMatchRouteExact('claimClaimant') || isMatchRouteExact('qClaimClaimant')">
        <v-card-text>
          <template v-if="claimantStatisticses.length > 0">
            <v-layout row wrap v-for="claimantStatistics in claimantStatisticses" :key="claimantStatistics.statType" align-center>
              <v-flex xs6>
                <v-subheader class="queryLabel">
                  <span>{{ claimantStatistics.statsTypeDesc }}</span>
                </v-subheader>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  v-validate="{ required: true }"
                  v-model="claimantStatistics.selectedVal"
                  :items="claimantStatistics.statValList"
                  label="Statistics"
                  item-text="label"
                  item-value="value"
                  data-vv-name="Statistics"
                  :data-vv-as="'Statistics'"
                  :error-messages="errors.collect('Statistics')"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </template>
          <template v-else>
            <v-layout justify-center>
              <div>No Statistic Found</div>
            </v-layout>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="doCancel">Cancel</v-btn>
          <v-btn color="primary" text @click="doValidate">Save</v-btn>
        </v-card-actions>
      </template>
      <template v-else-if="isMatchRouteExact('claimItem') || isMatchRouteExact('qClaimItem')">
        <v-card-text>
          <template v-if="itemStatisticses.length > 0">
            <v-layout row wrap v-for="itemStatistics in itemStatisticses" :key="itemStatistics.statType" align-center>
              <v-flex xs6>
                <v-subheader class="queryLabel">
                  <span>{{ itemStatistics.statsTypeDesc }}</span>
                </v-subheader>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  v-validate="{ required: true }"
                  v-model="itemStatistics.selectedVal"
                  :items="itemStatistics.statValList"
                  label="Statistics"
                  item-text="label"
                  item-value="value"
                  data-vv-name="Statistics"
                  :data-vv-as="'Statistics'"
                  :error-messages="errors.collect('Statistics')"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </template>
          <template v-else>
            <v-layout justify-center>
              <div>No Statistic Found</div>
            </v-layout>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="doCancel">Cancel</v-btn>
          <v-btn color="primary" text @click="doValidate">Save</v-btn>
        </v-card-actions>
      </template>
    </v-container>
  </v-card>
</template>

<script>
import clone from 'clone'
import MessageMixin from '@/mixins/message'
import * as TableConst from '@/mixins/table'
import routeMixin from '@/mixins/route'
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
export default {
  props: {
    clmtNo: {
      type: Number,
      default: 1
    },
    clmItem: {
      type: Number,
      default: 1
    },
    load: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      recordFound: false,
      claimantStatisticses: [],
      itemStatisticses: []
    }
  },
  computed: {
    statisticses() {
      let result = clone(this.$store.state.claims.claimDetail.commonInfo.statisticses)
      if (result.length > 0) {
        return result
      }
      return []
    },
    commonInfo() {
      return this.$store.state.claims.claimDetail.commonInfo
    },
    // commonDetail() {
    //   return this.$store.state.claims.claimDetail
    // },
    commonMenu() {
      return this.$store.state.commons
    }
  },
  watch: {
    load: function (value) {
      if (value) {
        this.doInit()
      }
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      if (this.commonMenu.init === 1) {
        this.fetchData()
      }
    },
    doCancel() {
      if (this.statisticsSection) {
        this.statisticsSection = false
      } else {
        this.$emit('close')
      }
    },
    doValidate() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          let apiUrl = null
          let formatObj = null
          if (this.$route.name === 'claimHeader') {
            formatObj = {
              clmNo: this.commonInfo.clmNo,
              statistics: this.statisticses
            }
            // apiUrl = this.commonDetail.menu.saveHeaderStatistics
            apiUrl = this.commonMenu.menu.saveHeaderStatistics
          } else if (this.$route.name === 'claimClaimant' || this.$route.name === 'qClaimClaimant') {
            formatObj = {
              clmNo: this.commonInfo.clmNo,
              clmtNo: this.clmtNo,
              statistics: this.claimantStatisticses
            }
            apiUrl = this.menu.saveClaimantStatistics
          } else if (this.$route.name === 'claimItem') {
            formatObj = {
              clmNo: this.commonInfo.clmNo,
              clmtNo: this.clmtNo,
              clmItem: this.clmItem,
              statistics: this.itemStatisticses
            }
            apiUrl = this.menu.saveClaimItemStatistics
          }
          this.doSave(apiUrl, formatObj)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doSave(apiUrl, formatObj) {
      if (apiUrl) {
        this.$http
          .post(apiUrl, formatObj)
          .then((result) => {
            if (result.data) {
              const data = result.data
              this.notify(data)
              this.$emit('close')
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.$toast.error('Fail to Save your Record')
              this.message(data)
              this.fieldMessage(data)
              return false
            }
          })
      } else {
        // this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async fetchData() {
      let apiUrl = null
      let formatObj = null
      if (this.$route.name === 'claimClaimant' || this.$route.name === 'qClaimClaimant') {
        // apiUrl = this.commonDetail.menu.claimantStatistics
        apiUrl = this.commonMenu.menu.claimantStatistics
        formatObj = {
          clmNo: this.commonInfo.clmNo,
          clmtNo: this.clmtNo
        }
      } else if (this.$route.name === 'claimItem') {
        // apiUrl = this.commonDetail.menu.claimItemStatistics
        apiUrl = this.commonMenu.menu.claimItemStatistics
        formatObj = {
          clmNo: this.commonInfo.clmNo,
          clmtNo: this.clmtNo,
          clmItem: this.clmItem
        }
      }
      if (formatObj !== null) {
        // try {
        if (apiUrl) {
          const result = await this.$http.get(expandURI(apiUrl, formatObj))
          const { data } = result.data
          this.menu = extractMenu(result.data._links)
          this.claimantStatisticses = []
          this.itemStatisticses = []
          if (data) {
            if (this.$route.name === 'claimClaimant' || this.$route.name === 'qClaimClaimant') {
              this.claimantStatisticses = data.statistics
            } else if (this.$route.name === 'claimItem') {
              this.itemStatisticses = data.statistics
            }
          }
        } else {
          this.$toast.error('The request failed because it is trying to execute an invalid API url.')
        }
        // } catch (err) {
        //   this.$toast.error('The request failed because it is trying to execute an invalid API url..')
        //   throw err
        // }
      }
    }
  },
  mounted() {
    this.doInit()
  },
  mixins: [MessageMixin, TableConst.default, routeMixin]
}
</script>

<style>
</style>
